
export const approveUserModel = ({
    userId,
    approvalStatus,
    firstName,
    lastName
}: Record<string, any> = {}) => ({
    id: userId,
    approvalStatus,
    firstName,
    lastName
});

export const userApprovalUpdateResultsModel = ({
    errors,
    numberUpdated,
    usersPendingApproval,

}: Record<string, any> = {}) => ({
    errors,
    numberUpdated,
    usersPendingApproval,
});